import { createApiHooks } from '@apis/next/common';
import {
  DashboardBookingInquiryPages,
  DashboardBookingInquiryQuery,
} from '@models/next/BookingInquiry';
import { StatusFlows } from '@models/next/StatusFlows';
import { z } from 'zod';

export const dashboardBookingInquiryApis = createApiHooks('/dashboard/booking-inquiry', [
  {
    method: 'get',
    path: '/:d2d_no/status-flows',
    parameters: [
      {
        type: 'Path',
        name: 'd2d_no',
        schema: z.string(),
      },
    ],
    response: StatusFlows,
  },
  {
    method: 'get',
    path: '',
    parameters: [
      {
        type: 'Query',
        name: 'query',
        schema: DashboardBookingInquiryQuery,
      },
    ],
    response: DashboardBookingInquiryPages,
  },
]);

export const bookingInquiryApis = createApiHooks('/booking-inquiry', [
  {
    method: 'get',
    path: '/:d2d_no/status-flows',
    parameters: [
      {
        type: 'Path',
        name: 'd2d_no',
        schema: z.string(),
      },
    ],
    response: StatusFlows,
  },
]);
